import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';

const RequestPageContent = dynamic(() => import('../components/RequestPageContent'), {
  ssr: false,
});

export default function RequestPage() {
  return (
    <>
      <Head>
        <title>REEFLI - Request</title>
        <meta name="description" content="Request form for katalog or design" />
      </Head>

      <Suspense fallback={<div className="p-20 text-center">Loading...</div>}>
        <RequestPageContent />
      </Suspense>
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'request',
        'navbar',
        'footer',
      ])),
    },
  };
}
